import $ from 'jquery';
import ACTION from '../action_constant';
import {ajaxGetWithToken ,ajaxPostWithToken} from '../util/ajax';
import API from '../api_config';

const dashboardActions = {
  getShipmentPackages: () => {
    return (dispatch) => {
      return ajaxGetWithToken({
        url: API.shippingDashboard,
        success: (data) => {
          const shipments = data.shipments;

          dispatch({
            type: ACTION.DASHBOARD.ADD_SHIPMENT_PACKAGES,
            data : {
              shipments : shipments,
              shippingCount: data.shippingCount,
              carryingCount: data.carryingCount,
              receivingCount: data.receivingCount
            }
          });
        },
        error: (error) => {
        }
      });
    }
  },
  getCarryingPackages: () => {
    return (dispatch) => {
      return ajaxGetWithToken({
        url: API.carryingDashboard,
        success: (data) => {
          const shipments = data.shipments;

          dispatch({
            type: ACTION.DASHBOARD.ADD_CARRYING_PACKAGES,
            data : {
              shipments : shipments,
              carryingCount: data.carryingCount,
              shippingCount: data.shippingCount,
              receivingCount: data.receivingCount
            }
          });
        },
        error: (error) => {
        }
      });
    }
  },
  getRecievingPackages: () => {
    return (dispatch) => {
      return ajaxGetWithToken({
        url: API.receivingDashboard,
        success: (data) => {
          const shipments = data.shipments;

          dispatch({
            type: ACTION.DASHBOARD.ADD_RECEIVING_PACKAGES,
            data : {
              shipments : shipments,
              carryingCount: data.carryingCount,
              shippingCount: data.shippingCount,
              receivingCount: data.receivingCount
            }
          });
        },
        error: (error) => {
        }
      });
    }
  },
  cancelOffer : (paramObj) => {
    return (dispatch) => {
      return ajaxPostWithToken({
        url : API.cancelOffer,
        data: paramObj,
        success: (data) => {
        },
        error: (error) => {
        }
      });
    }
  },
  deleteShipment : (paramObj) => {
    return (dispatch) => {
      return ajaxPostWithToken({
        url : API.deleteShipment,
        data: paramObj,
        success: (data) => {
        },
        error: (error) => {
        }
      });
    }
  },
  cancelShimentBeforeHandOff : (paramObj) => {
    return (dispatch) => {
      return ajaxPostWithToken({
        url : API.cancelShimentBeforeHandOff,
        data: paramObj,
        success: (data) => {
        },
        error: (error) => {
        }
      });
    }
  }
}

module.exports = dashboardActions;



// WEBPACK FOOTER //
// app/dashboard/dashboard_actions.jsx